import React, { useState, useEffect, useContext, useRef } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { styled, alpha } from '@mui/material/styles';
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Grid, FormControl, Input, Divider } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import EmployeeBenefitsMenu from "components/Menu/EmployeeBenefitsMenu";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import moment from "moment";
import { Utils } from "common/Utils";
import * as Yup from 'yup';
import AximTooltip from "components/AximTooltip";

const CensusChooseEmployeeModal = ({ openChooseEmployeesModal, handleChooseEmployeesClose,employeesNotInList,setEmployeesNotInList,employeesToAdd,setEmployeesToAdd,handleSaveAddEmployee }) => {

  const formatSSN = (val) => "XXX-XX-" + val.replaceAll("-", "").slice(5);
  
  const toggleAddEmployee = (insuredId, checked) => {
    console.log('toggleAddEmployee')
    console.log(insuredId)
    console.log(checked)
    let ees = [...employeesNotInList];
    console.log(ees, 'ees')
    let empIdx = ees.findIndex(e => e.insuredID == insuredId);
    ees[empIdx].toAdd = checked;

    setEmployeesNotInList(ees);
    if (checked) {
      console.log([...employeesToAdd, ...ees.filter(e => e.insuredID == insuredId)])
      setEmployeesToAdd([...employeesToAdd, ...ees.filter(e => e.insuredID == insuredId)])
    }
    else {
      console.log(employeesToAdd.filter(e => e.insuredID != insuredId))
      setEmployeesToAdd(employeesToAdd.filter(e => e.insuredID != insuredId))
    }
  }


  const chooseEmployeeColumns = [
    {
      Header: "",
      accessor: "toAdd",
      Cell: ({ row }) => (
        <Box >
          <Checkbox
            checked={row.values.toAdd}
            onChange={e => toggleAddEmployee(row.values.insuredID, e.target.checked)}
          ></Checkbox>
        </Box>
      )
    },
    {
      Header: "InsuredID",
      accessor: "insuredID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "benefitPackageID",
      accessor: "benefitPackageID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "First Name",
      accessor: "firstName",
    },
    {
      Header: "Last Name",
      accessor: "lastName",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "SSN",
      accessor: "ssn",
      Cell: ({ row }) => (
        <Box >
          {formatSSN(row.values.ssn)}
        </Box>
      )
    },
    {
      Header: "Job Title",
      accessor: "jobTitle",
    },
    {
      Header: "DOB",
      accessor: "birthDateStr",
    },
    {
      Header: "DOH",
      accessor: "hireDateStr",
    },
    {
      Header: "Term Date",
      accessor: "termDateStr",
    },
    {
      Header: "Hourly Salary",
      accessor: "hourlySalary",
    }
  ];



  return (
    <>
      
      <Dialog
        open={openChooseEmployeesModal}
        onClose={handleChooseEmployeesClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Choose Employees
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          <TableAllData columns={chooseEmployeeColumns} data={employeesNotInList} />
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            onClick={handleSaveAddEmployee}
            className={ButtonStyle.CsubmitBtn}
          >
            Save
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleChooseEmployeesClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </>
  )
};

export default CensusChooseEmployeeModal;